import { Component, Input } from '@angular/core'

@Component({
  selector: 'app-retention-badge',
  templateUrl: './retention-badge.component.html',
  styleUrls: ['./retention-badge.component.scss']
})
export class RetentionBadgeComponent {
  @Input() retention: any = null
  @Input() compact: boolean = false
  @Input() admin: boolean = false

  get show(): boolean {
    if(!this.retention) return false
    const s = this.retention.state
    return s === 'grace' || s === 'expired_grace'
  }

  get expired(): boolean {
    return !!this.retention && Number(this.retention.daysLeft) <= 0
  }

  get daysLabel(): string {
    if(!this.retention) return ''
    const d = Number(this.retention.daysLeft)
    return d > 0 ? d + 'д' : '0д'
  }

  get noticesTooltip(): string {
    if(!this.retention) return ''
    const parts: string[] = []
    if(this.retention.lastUserNoticeSentAt){
      parts.push('user notice: ' + new Date(this.retention.lastUserNoticeSentAt).toISOString().slice(0,10))
    }
    if(this.retention.lastAdminNoticeSentAt){
      parts.push('admin notice: ' + new Date(this.retention.lastAdminNoticeSentAt).toISOString().slice(0,10))
    }
    return parts.join(' · ')
  }
}
